<template>
	<div v-if="props.open" class="fixed z-30 bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center">
		<div class="fixed inset-0 transition-opacity">
			<div class="absolute inset-0 bg-gray-900 opacity-75" @click="emit('close')" data-heap="exit-slide-edit-background"></div>
		</div>
	<div class="max-w-6xl mx-auto py-6 sm:px-6 lg:px-8 z-10">
		<!-- Replace with your content -->

		<div class="bg-white p-4 rounded-lg shadow-xl ">
			<div class="flex items-center justify-between mb-3 rounded-lg px-1">
				<div class="flex items-center">
					<h2 class="text-2xl font-googleBold">Edit Slide</h2>
					<p class="text-gray-500 text-sm ml-2"><span class="bg-gray-200 m-2 px-2 py-1 rounded-xl text-gray-800 text-xs">{{ props.pendingSlidesCount }}</span> slide{{ props.pendingSlidesCount === 1 ? '' : 's' }} in queue</p>
				</div>
				<svg data-heap="exit-slide-edit-button" @click="$emit('close')" class="w-6 h-6 cursor-pointer" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
			</div>

			<!-- Meta data -->
			<div class="border border-gray-300 mt-4 mb-5 rounded-lg p-2">
				<div class="flex justify-between text-sm text-gray-600">
					<div class="flex">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5">
							<path fill-rule="evenodd" d="M5.75 2a.75.75 0 0 1 .75.75V4h7V2.75a.75.75 0 0 1 1.5 0V4h.25A2.75 2.75 0 0 1 18 6.75v8.5A2.75 2.75 0 0 1 15.25 18H4.75A2.75 2.75 0 0 1 2 15.25v-8.5A2.75 2.75 0 0 1 4.75 4H5V2.75A.75.75 0 0 1 5.75 2Zm-1 5.5c-.69 0-1.25.56-1.25 1.25v6.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25v-6.5c0-.69-.56-1.25-1.25-1.25H4.75Z" clip-rule="evenodd" />
						</svg>
						<span class="ml-1">{{ new Date(currentSlide.created_at).toDateString() }}</span>

					</div>

					<div class="flex">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5">
							<path fill-rule="evenodd" d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm.75-13a.75.75 0 0 0-1.5 0v5c0 .414.336.75.75.75h4a.75.75 0 0 0 0-1.5h-3.25V5Z" clip-rule="evenodd" />
						</svg>

						<span class="ml-1">{{ Math.floor(((new Date()) - (new Date(currentSlide.created_at))) / (1000 * 60 * 60 * 24)) }} days since saved</span>

					</div>


					<div class="flex">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5">
							<path fill-rule="evenodd" d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-5.5-2.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM10 12a5.99 5.99 0 0 0-4.793 2.39A6.483 6.483 0 0 0 10 16.5a6.483 6.483 0 0 0 4.793-2.11A5.99 5.99 0 0 0 10 12Z" clip-rule="evenodd" />
						</svg>

						<span class="ml-1">{{ currentSlide.user?.name }}</span>

					</div>


					<div class="flex">
						<!--						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5">-->
						<!--							<path d="M12.232 4.232a2.5 2.5 0 0 1 3.536 3.536l-1.225 1.224a.75.75 0 0 0 1.061 1.06l1.224-1.224a4 4 0 0 0-5.656-5.656l-3 3a4 4 0 0 0 .225 5.865.75.75 0 0 0 .977-1.138 2.5 2.5 0 0 1-.142-3.667l3-3Z" />-->
						<!--							<path d="M11.603 7.963a.75.75 0 0 0-.977 1.138 2.5 2.5 0 0 1 .142 3.667l-3 3a2.5 2.5 0 0 1-3.536-3.536l1.225-1.224a.75.75 0 0 0-1.061-1.06l-1.224 1.224a4 4 0 1 0 5.656 5.656l3-3a4 4 0 0 0-.225-5.865Z" />-->
						<!--						</svg>-->

						<svg fill="currentColor" class="w-5 h-5 rounded" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill="#F1B100" d="M0 0h64v64H0V0Z"/><path fill="#FFF" d="M7 18h50v28H7V18Z"/></svg>

						<a data-heap="click-outbound-original-pres-link" class="ml-1" :href="currentSlide.original_url" target="_blank" rel="noopener noreferrer">{{ currentSlide.original_url ? 'Original Presentation' : 'not set' }}</a>

					</div>

				</div>
			</div>
			<!-- End Meta Data -->



			<div class="grid grid-cols-2 gap-6">
				<div class="border border-gray-300 rounded-lg">
					<img :src="currentSlide.qualified_url" alt="" class="w-full rounded-lg">
				</div>
				<div class="relative">
					<div
						class="-m-px border border-gray-300 h-full rounded-lg shadow-sm focus-within:border-indigo-500 focus-within:ring-1 focus-within:ring-indigo-500">
						<input type="text" name="title" id="title"
							   class="block w-full border-0 pt-2.5 text-lg font-medium bg-transparent placeholder-gray-500 focus:ring-0"
							   v-model="form.slideTitle"
							   placeholder="Slide Title"/>
						<textarea rows="4" name="description" id="description"
								  v-model="form.description"
								  class="block w-full border-0 py-0 resize-none placeholder-gray-500 focus:ring-0 sm:text-sm"
								  placeholder="Add a description or notes for later..."/>


						<div class="absolute bottom-0 w-full">

							<div class="flex justify-end flex-wrap py-2 px-2 gap-2 sm:px-3">

								<div v-for="(selectedTag,index) in selectedTags" :key=index
									 class="relative inline-flex items-center rounded-full py-1 px-2 text-sm font-medium  whitespace-nowrap"
									:class="[newTagEntry.toLowerCase() === selectedTag.name.toLowerCase() ? 'bg-indigo-600 opacity-100 text-white hover:bg-indigo-700 drop-shadow-md' : 'bg-gray-50 text-gray-500 hover:bg-gray-100 text-gray-900' ]"
								>
									<span>{{ selectedTag.name }}</span>
									<button @click="removeTag(selectedTag)">
										<svg xmlns="http://www.w3.org/2000/svg"
											 class="flex-shrink-0 h-5 w-5 ml-1 text-gray-300" viewBox="0 0 20 20"
											 fill="currentColor">
											<path fill-rule="evenodd"
												  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
												  clip-rule="evenodd"/>
										</svg>
									</button>

								</div>


								<!-- Add Tag dropdown -->
								<div class="relative sm:inline-block text-left ">


									<button @click="tagDropdownOpen = !tagDropdownOpen" type="button"
											data-heap="open-add-tag-menu"
											class="h-full relative inline-flex items-center rounded-full py-1 px-2 bg-gray-50 text-sm font-medium text-gray-500 whitespace-nowrap hover:bg-gray-100">
										<svg xmlns="http://www.w3.org/2000/svg" class="flex-shrink-0 h-5 w-5 sm:-ml-1 mr-1 text-gray-300" viewBox="0 0 20 20" fill="currentColor">
											<path fill-rule="evenodd" d="M17.707 9.293a1 1 0 010 1.414l-7 7a1 1 0 01-1.414 0l-7-7A.997.997 0 012 10V5a3 3 0 013-3h5c.256 0 .512.098.707.293l7 7zM5 6a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
										</svg>
										<span class="text-gray-900">Add Tag</span>
									</button>


									<!--Full width button to close if you click outside-->
									<button data-heap="close-add-tag-menu" v-if="tagDropdownOpen" @click="tagDropdownOpen = false"
											tabindex="-1" class="fixed inset-0 h-full w-full cursor-default">
									</button>

									<!-- Tag Modal -->
									<transition enter-active-class="transition ease-out duration-200" enter-from-class="opacity-0 translate-y-1" enter-to-class="opacity-100 translate-y-0" leave-active-class="transition ease-in duration-150" leave-from-class="opacity-100 translate-y-0" leave-to-class="opacity-0 translate-y-1">
										<div v-if="tagDropdownOpen" class="absolute -right-2 z-10 mt-4 flex w-screen max-w-max px-4">
											<div class="w-screen max-w-md flex-auto overflow-hidden rounded-3xl bg-white text-sm leading-6 shadow-lg ring-1 ring-gray-900/5">
												<div class="p-2 flex flex-wrap">
													<span v-for="(tag,index) in tags" :key=index @click="selectTag(tag)" data-heap="select-tag"
														  class=" border border-indigo-600 font-medium hover:opacity-100 items-center my-2 mx-2 px-2 py-1 relative rounded-full text-xs whitespace-nowrap cursor-pointer"
														  :class="[newTagEntry.toLowerCase() === tag.name.toLowerCase() ? 'bg-indigo-600 opacity-100 text-white hover:bg-indigo-700 drop-shadow-md' : 'bg-indigo-100 opacity-75 text-indigo-900 hover:bg-indigo-200']"
													>
														<span class="font-googleBold">{{ tag.name }}</span>
													</span>
												</div>


												<div class="grid grid-cols-1 divide-x border-t" >
													<div class="flex mx-4 h-[46px]">
														<input type="text" name="title" id="searchTag" data-heap="add-tag-input"
															   class="block w-full border-0 text-sm font-medium placeholder-gray-500 focus:ring-0"
															   placeholder="Add new tag..."
															   v-model="newTagEntry"
															   @keydown.space.stop
															   @keydown.enter.prevent="addTag()"
														/>
														<button data-heap="add-tag" v-if="newTagEntry.length > 0" @click="addTag()" class="border border-gray-300 hover:bg-gray-100 hover:cursor-pointer m-2 w-24 flex justify-center p-2 rounded shadow">
															<svg class="h-3 fill-gray-600" viewBox="-148.269 -27.249 512 377.175" xmlns="http://www.w3.org/2000/svg"><path d="M310.1313-27.249v184.975h-355.2l96.1-98.4-37.8-38.6-161.5 164.6 161.5 164.6 37.8-38.6-96.1-98.4h408.8V-27.249z"/></svg>
														</button>
													</div>
												</div>


											</div>

										</div>
									</transition>
								</div>



							</div>
							<div
								class="border-t border-gray-200 px-2 py-2 flex justify-between items-center space-x-3 sm:px-3">
								<div class="flex">
									<Listbox as="div" v-model="selectedCollection" class="flex-shrink-0">
										<div class="relative">
											<ListboxButton data-heap="select-collection-in-modal" class="relative inline-flex items-center rounded-full py-2 px-2 bg-gray-50 text-sm font-medium text-gray-500 whitespace-nowrap hover:bg-gray-100 sm:px-3">
												<svg :class="[selectedCollection.value === null ? 'text-gray-300' : 'text-gray-500', 'flex-shrink-0 h-5 w-5 sm:-ml-1']" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
													<path d="M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zM2 11a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z" />
												</svg>
												<span :class="[selectedCollection.value === null ? '' : 'text-gray-900', 'hidden truncate sm:ml-2 sm:block']">{{ selectedCollection.value === null ? 'Collection' : selectedCollection.name }}</span>
											</ListboxButton>

											<transition leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100" leave-to-class="opacity-0">
												<ListboxOptions class="absolute z-10 mt-1 w-52 bg-white shadow max-h-56 rounded-lg py-3 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
													<ListboxOption as="template" v-for="collection in props.collections" :key="collection.short_name" :value=collection v-slot="{ active,selected }">
														<li :class="[active ? 'bg-gray-100' : 'bg-white', 'cursor-default select-none relative py-2 px-3']">
															<div class="flex items-center">
																<span class="block font-medium truncate">
																	{{ collection.name }} <span class="bg-gray-100 rounded-xl m-2 text-xs py-1 px-2 text-gray-800">{{collection.slides_count}}</span>
																</span>
																<span
																	v-if="selected"
																	class="absolute inset-y-0 right-0 flex items-center pr-3">
																	<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
																		<path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
																	</svg>
																</span>
															</div>
														</li>
													</ListboxOption>
												</ListboxOptions>
											</transition>
										</div>
									</Listbox>

									<!-- visible / hidden icon -->

									<button data-heap="set-visibility-in-slide-modal" @click="form.private = !form.private" type="button"
											class="relative inline-flex items-center rounded-full ml-2 py-2 px-2 bg-gray-50 text-sm font-medium text-gray-500 whitespace-nowrap hover:bg-gray-100 sm:px-3">

										<!-- eye open -->
										<span v-if="!form.private" class="inline-flex">
											<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="flex-shrink-0 h-5 w-5 sm:-ml-1 mr-1 text-gray-500">
												<path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
												<path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
											</svg>
											<span class="text-gray-900 ml-2">Shared</span>
										</span>

										<!-- eye closed -->
										<span v-else class="inline-flex">
											<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="flex-shrink-0 h-5 w-5 sm:-ml-1 mr-1 text-gray-500">
												<path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
											</svg>
											<span class="text-gray-900 ml-2">Private</span>
										</span>
									</button>




								</div>
								<div class="flex items-center flex-shrink-0">
									<div data-heap="delete-slide-start" @click="pendingDelete = true" v-if="!pendingDelete" class="hover:text-red-400 pr-3 text-gray-400 cursor-pointer">
										<!-- trash can symbol -->
										<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path></svg>
									</div>
									<div data-heap="delete-slide-cancel" @click="pendingDelete = false" v-if="pendingDelete" class="hover:text-indigo-600 pr-3 text-gray-400 cursor-pointer">
										<!-- go back symbol-->
										<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"></path></svg>
									</div>
									<button data-heap="delete-slide-confirm" @click="deleteSlide()" v-if="pendingDelete" class="bg-red-200 border border-transparent focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 font-medium hover:bg-red-300 inline-flex items-center mr-3 px-4 py-2 rounded-md shadow-sm text-red-800 text-sm cursor-pointer">
										Confirm
									</button>

									<!-- submit button -->
									<button data-heap="confirm-slide-save" @click="submit()"
											class="items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white w-28 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
											:class="[form.slideTitle.length > 0 ? 'bg-indigo-600 hover:bg-indigo-700' : 'bg-gray-200 cursor-not-allowed hover:bg-gray-300']"
											:disabled="(form.slideTitle.length < 0) || form.processing"

									>
										<span v-if="!form.processing">
											Save Slide
										</span>
										<span v-else class="flex justify-center w-full">
											<svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
												<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
												<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
											</svg>
										</span>
									</button>
								</div>
							</div>
						</div>



					</div>


				</div>



			</div> <!-- Grid end --->

			<!-- Form warning -->
			<div class="rounded-lg bg-red-50 p-4 self-center mt-4" v-if="submitHadError">
				<div class="flex" >
					<div class="flex-shrink-0">
						<svg class="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
							<path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
						</svg>
					</div>
					<div class="ml-3">
						<h3 class="text-sm font-medium text-red-800">Looks like something went wrong. Mind trying again? This error was logged in the meantime.</h3>
					</div>
				</div>
			</div>


		</div>
	</div>

	</div>



</template>

<script setup>
import { ref, onMounted} from "vue";

import {Listbox, ListboxButton, ListboxOption, ListboxOptions} from '@headlessui/vue'
import {
	selectedTags,
	tags,
	addTag,
	selectTag,
	removeTag,
	newTagEntry,
	setupTagsOnLoad,
	createSlideForm
} from "@/Pages/SlideRepo/Utils/slideHelpers";

const props = defineProps({
	open: {type: Boolean, default: false},
	collections: {type: Object, default: {"name":"Personal","short_name":"personal","slides_count":0} },
	activeCollection: {type: Object },
	tags: Object,
	pendingSlides: Object,
	pendingSlidesCount: Number,
	editSlide: {type: Object, Default: {}}
});



onMounted(() => {

	if(props.editSlide) { // this means we're in an edit request
		currentSlide.value = props.editSlide;
		form.slideTitle = props.editSlide.title;
		form.description = props.editSlide.description;
		selectedTags.value = props.editSlide.tags;
		form.private = props.editSlide.private;
	} else {
		currentSlide.value = props.pendingSlides[Object.keys(props.pendingSlides)[0]];
	}

	setupTagsOnLoad(props);

});

let currentSlide = ref({});

let pendingDelete = ref(false);

let selectedCollection = ref(props.activeCollection)

const form = createSlideForm(currentSlide, selectedCollection);

const tagDropdownOpen = ref(false)

const clipboard = ref([]);
const emit = defineEmits(['close']);

function deleteSlide() {

	form.transform((data) => ({
		...data,
		slideID: currentSlide.value.id,
		user_id: currentSlide.value.user_id

	})).delete('/repository', {
		onSuccess: () => {
			pendingDelete.value = false;
			handleFormSuccess();
		}
	});
}

const submitHadError = ref(false);
function submit() {

	submitHadError.value = false;

	form
		.transform((data) => ({
			...data,
			tags: selectedTags.value,
			slideID: currentSlide.value.id,
			user_id: currentSlide.value.user_id,
			type: currentSlide.value.type

		}))
		.post('/repository', {
			forceFormData: true,
			preserveScroll: true,
			onSuccess: () => {
				handleFormSuccess();
			},
			onError: () => {
				submitHadError.value = true;
			}
		});


}

function handleFormSuccess() {
	// pull in new information and clear the form
	currentSlide.value = props.pendingSlides[Object.keys(props.pendingSlides)[0]];
	form.slideTitle = '';
	form.description = '';
	form.collection = props.activeCollection;
	form.tags = [];
	selectedTags.value = [];
	form.private = false;
	setupTagsOnLoad(props); // setup tags fresh

	if(props.pendingSlidesCount === 0 || props.editSlide != null) {
		emit('close'); // this means there are no more to process so we can close the modal, OR it was an edit request so we shouldn't keep going
	}

}




</script>
